import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import moment from 'moment';
const max = moment().unix() * 1000;
const min = max - (7 * 24 * 60 * 60) * 1000;
const defaultTimeRange = () => { return { min: min, max: max }; };
const state = {
    state: ''
};
const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
export default module;
